// TODO(HOPE): This will need to be replaced in the future with TanStack table
import React from "react";

import type { Column } from "../../types";
import styles from "./DataTable.module.css";

export interface DataTableProps {
  title?: string;
  headers: string[];
  cols: Column[];
  data: any[];
  tableProps?: React.TableHTMLAttributes<HTMLTableElement>;
  options?: {
    showTitle?: boolean;
  };
}

const defaultOptions = {
  showTitle: true,
};

const DataTable: React.FC<DataTableProps> = ({
  title,
  headers,
  cols,
  data,
  tableProps,
  options = defaultOptions,
}) => {
  const colCount = headers.length;

  return (
    <table
      className={`${styles.displayTable} ${
        options.showTitle ? styles.hasCaption : ""
      }`}
      {...tableProps}
    >
      {options.showTitle && <caption>{title}</caption>}
      <thead>
        <tr className={styles.headerRow}>
          {headers.map((name, index) => (
            <th
              key={index}
              className={styles.dataHead}
              style={{ width: `${100 / colCount}%` }}
            >
              {name}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {data.map((dataRow, index) => (
          <tr key={index} className={styles.dataRow}>
            {dataRow
              ? cols.map((col) => {
                  let value = dataRow[col.key];
                  if (col.transform) {
                    value = col.transform(value, col, index, data.length);
                  }
                  let name = value;
                  if (col.url) {
                    let url =
                      typeof col.url === "function"
                        ? col.url(dataRow)
                        : col.url;
                    value = (
                      <a href={url} target="_blank" rel="noreferrer">
                        {value}
                      </a>
                    );
                  }
                  const title = `Dashboard for account: ${name}`;
                  return col.component ? (
                    <col.component
                      compKey={col.key}
                      key={`${index}-${col.key}`}
                      className={styles.dataCell}
                      style={{ width: `${100 / colCount}%` }}
                      value={value}
                    />
                  ) : (
                    <td
                      key={`${index}-${col.key}`}
                      className={styles.dataCell}
                      title={title}
                    >
                      {/* Unicode for &nbsp; */}
                      {value === "" ? "\u00A0" : value}
                    </td>
                  );
                })
              : // Create an empty cell for each column if dataRow is null
                // This is so that tables will line up/be the same size as each other even if some have empty rows
                cols.map((col, colIndex) => (
                  <td
                    key={`${index}-${colIndex}`}
                    className={styles.dataCell}
                    style={{ width: `${100 / colCount}%` }}
                  >
                    {/* Unicode for &nbsp; */}
                    {"\u00A0"}
                  </td>
                ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DataTable;
